var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 0.315025C10.8966 0.113253 10.6221 0 10.3359 0C10.0497 0 9.77509 0.113253 9.57212 0.315025L5.68295 4.15002L1.84795 0.315025C1.64497 0.113253 1.3704 0 1.0842 0C0.797997 0 0.523424 0.113253 0.320448 0.315025C0.218909 0.415735 0.138315 0.535553 0.0833156 0.667567C0.0283162 0.799581 0 0.941179 0 1.08419C0 1.2272 0.0283162 1.3688 0.0833156 1.50082C0.138315 1.63283 0.218909 1.75265 0.320448 1.85336L4.91378 6.44669C5.01449 6.54823 5.13431 6.62882 5.26632 6.68382C5.39834 6.73882 5.53994 6.76714 5.68295 6.76714C5.82596 6.76714 5.96756 6.73882 6.09957 6.68382C6.23159 6.62882 6.3514 6.54823 6.45211 6.44669L11.0996 1.85336C11.2012 1.75265 11.2817 1.63283 11.3367 1.50082C11.3917 1.3688 11.4201 1.2272 11.4201 1.08419C11.4201 0.941179 11.3917 0.799581 11.3367 0.667567C11.2817 0.535553 11.2012 0.415735 11.0996 0.315025Z",
    fill: "#2E75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.7bedebe00862f304b1f35a48b4749a29.svg";
export { ForwardRef as ReactComponent };